import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserControlCommunicationService } from './browserControlCommunication.service';
import { CommunicatorService } from './communicator.service';
import { SnackbarService } from './snackbar.service';
import { DataLayerService } from './data-layer.service';
import { VcrService } from './vcr.service';
import { GmSltService } from './gm-slt.service';
import { PdfService } from './pdf.service';
import { DealerTimezoneService } from './dealer-timezone.service';
import { GmTireCentralService } from './gm-tire-central.service';
import { ServiceVisitRecordService } from './service-visit-record.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    BrowserControlCommunicationService,
    CommunicatorService,
    DataLayerService,
    VcrService,
    SnackbarService,
    GmSltService,
    PdfService,
    DealerTimezoneService,
    GmTireCentralService,
    ServiceVisitRecordService,
  ],
})
export class ShaServicesModule {}
